import { Button, Typography, Box } from "@mui/material";
import { Link } from "react-router";

const Logout = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      width: "100vw",
      position: "absolute",
      top: 0,
      left: 0,
      background: "linear-gradient(135deg, #ffffff, #dcdcdc)",
    }}
  >
    <Box sx={{ textAlign: "center", padding: 2 }}>
      <Typography variant="h4" gutterBottom sx={{ color: "#1e3a8a" }}>
        Logged Out
      </Typography>
      <Box
        sx={{
          backgroundColor: "rgba(255, 255, 255, 0.6)",
          padding: 3,
          borderRadius: 0,
          maxWidth: 400,
          border: "1px solid rgba(200, 200, 200, 0.5)",
          backdropFilter: "blur(10px)",
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          You have been successfully logged out.
        </Typography>
        <Button
          fullWidth
          variant="contained"
          sx={{
            backgroundColor: "#131517",
            "&:hover": { backgroundColor: "#1e40af" },
            mt: 2,
          }}
          component={Link}
          to="/login"
        >
          Back to Login
        </Button>
      </Box>
    </Box>
  </Box>
);

export default Logout;
